import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ListItem, ListItemButton } from "@mui/material";
import { Link } from "react-router";
export const StatusListItem = ({ label, to, onClick, status, secondaryAction, dense = false, children, }) => (_jsxs(ListItem, { disablePadding: true, dense: dense, sx: {
        display: "grid",
        gridTemplateColumns: "auto minmax(0, 1fr) auto",
        alignItems: "center",
    }, children: [_jsx(ListItemButton, { ...(to
                ? { component: Link, to }
                : { component: "button", type: "button", onClick }), "aria-label": label, sx: { gridArea: "1 / 1 / 2 / 4", alignSelf: "stretch" } }), _jsx(Box, { sx: {
                gridArea: "1 / 1",
                ml: 1,
                display: "flex",
                zIndex: 1,
                pointerEvents: "none",
                "& button": { pointerEvents: "auto" },
            }, children: status }), _jsx(Box, { sx: {
                gridArea: "1 / 2",
                display: "flex",
                alignItems: "center",
                gap: 1,
                ml: 2,
                mr: 2,
                py: dense ? 0.5 : 1,
                minWidth: 0,
                pointerEvents: "none",
                zIndex: 1,
            }, children: children }), secondaryAction && (_jsx(Box, { sx: {
                gridArea: "1 / 3",
                mr: 1,
                display: "flex",
                zIndex: 1,
                pointerEvents: "none",
                "& button": { pointerEvents: "auto" },
            }, children: secondaryAction }))] }));
//# sourceMappingURL=StatusListItem.js.map